import React from 'react';
import PropTypes from 'prop-types';
import './PosterGrid.css';

export default function PosterSelection({
  selectedStamp,
  selectedOptionIndex,
  onPrintOptionChange,
  selectedOption,
  calculatedPrice,
  copies,
}) {
  if (!selectedStamp) return null;

  return (
    <div className="poster-selection">
      <label htmlFor="option-select">
        Selecciona la cantidad de estampitas que necesitas
      </label>
      <select
        id="option-select"
        value={selectedOptionIndex !== null ? selectedOptionIndex : ''}
        onChange={onPrintOptionChange}
      >
        <option value="" disabled>
          Selecciona una cantidad de impresión
        </option>
        {selectedStamp.options.map((option, index) => (
          <option key={option.type} value={index}>
            {option.type}
          </option>
        ))}
      </select>

      {selectedOption && (
        <div className="option-details">
          <p>Seleccionaste <strong>{copies}</strong> estampitas y el subtotal es <strong>${calculatedPrice}</strong></p>
        </div>
      )}
    </div>
  );
}

PosterSelection.propTypes = {
  selectedStamp: PropTypes.shape({
    id: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        description: PropTypes.string,
      })
    ),
  }),
  selectedOptionIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  onPrintOptionChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.shape({
    price: PropTypes.number.isRequired,
    description: PropTypes.string,
  }),
  calculatedPrice: PropTypes.number.isRequired,
  copies: PropTypes.number.isRequired,
};

PosterSelection.defaultProps = {
  selectedStamp: null,
  selectedOptionIndex: null,
  selectedOption: null,
};
